import { render, staticRenderFns } from "./MerchantMemberInit.vue?vue&type=template&id=20710b5e&scoped=true"
import script from "./MerchantMemberInit.vue?vue&type=script&lang=js"
export * from "./MerchantMemberInit.vue?vue&type=script&lang=js"
import style0 from "./MerchantMemberInit.vue?vue&type=style&index=0&id=20710b5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20710b5e",
  null
  
)

export default component.exports